<template>
    <Poptip
        placement="bottom-start"
        class="hide-title"
        :class="$style.container"
        :popper-class="isDarkTheme ? 'theme-campaign-dark' : ''"
        trigger="hover"
        transfer
    >
        <span :class="$style.name" data-testid="banner-footer-name">
            {{ bannerName }}
        </span>

        <template #content>
            <div>
                <p>{{ bannerName }}</p>
            </div>
        </template>
    </Poptip>
</template>

<script lang="ts" setup>
const { isDarkTheme, bannerName } = defineProps<{
    isDarkTheme: boolean;
    bannerName: string;
}>();
</script>

<style lang="css" module>
.container {
    flex: 1 0;
    text-align: left;
    overflow: hidden;
}

.name {
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 12px;
}
</style>
